import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

jQuery(function ($) {
	if ($('.quant-wrapper').length) {
		gsap.registerPlugin(ScrollTrigger);

		function animateQuant(el) {
			if (!$(el).hasClass('animated')) {
				var $quant = $(el).find('.quant');
				var sup = $quant.find('sup').prop('outerHTML') || '';
				$quant.prop('Counter', 0).animate({
					Counter: $quant.data('number')
				}, {
					duration: 1000,
					easing: 'swing',
					step: function (now) {
						var target = $quant.data('number');
						var formatted = target % 1 !== 0 ? now.toFixed(1) : Math.ceil(now);
						$(this).html(formatted + sup);
					}
				});

				$(el).addClass('animated');
			}
		}

		let trigger = gsap.utils.toArray('.quant-wrapper');

		trigger.forEach((element) => {
			gsap.timeline({
				scrollTrigger: {
					trigger: element,
					start: 'bottom bottom',
					onEnter: function () {
						animateQuant(element);
					},
					markers: false,
				}
			});
		});
	}
});
